// Import necessary modules for making requests (e.g., axios, fetch)
import axios from 'axios';

const SearchResults = () => {
    const postTypeFilter = document.querySelector('.filter-by-post-type');
    if (!postTypeFilter) return;

    const postType = postTypeFilter.querySelectorAll('.facet-value');

    // Event listener for each post type filter
    postType.forEach((type) => {
        type.addEventListener('click', (e) => {
            e.preventDefault();
            
            // Toggle checkbox state
            const checkbox = type.querySelector('input[type="checkbox"]');
            checkbox.checked = !checkbox.checked;
            console.log('Filter by post type:', checkbox.value);

            // Collect all selected post types
            const selectedPostTypes = [...postTypeFilter.querySelectorAll('input[type="checkbox"]:checked')]
                .map(checkbox => checkbox.value);

            // Update search results based on selected post types
            updateSearchResults(selectedPostTypes);
        });
    });
}

// Function to update search results
const updateSearchResults = async (selectedPostTypes) => {
    try {

        // Get search phrase from url
        const urlParams = new URLSearchParams(window.location.search);
        const searchPhrase = urlParams.get('s');

        // Example API call, adjust URL and parameters as needed
        const response = await axios.get('/wp-json/wp/v2/search', {
            params: {
                //type: 'post',  // This specifies we're searching for posts; adjust as needed
                subType: selectedPostTypes.join(','),
                search: searchPhrase
            }
        });

        console.log('Search results:', response);

        // Assuming your search results container has an ID of 'search-results-list'
        const resultsContainer = document.getElementById('search-results-list');
        
        // Clear the existing results
        resultsContainer.innerHTML = '';

        if (response.data.length > 0) {
            // Render new search results
            response.data.forEach(result => {
                // Example rendering, adjust to match your template
                const resultElement = document.createElement('div');
                resultElement.className = 'search-result-item';
                resultElement.innerHTML = `
                    <h3>${result.title}</h3>
                    <p>${result.excerpt}</p>
                    <a href="${result.url}">Read more</a>
                `;
                resultsContainer.appendChild(resultElement);
            });
        } else {
            // Handle case with no results
            resultsContainer.innerHTML = '<p>No results found.</p>';
        }

    } catch (error) {
        console.error('Error updating search results:', error);

        // Handle error case, e.g., display an error message in the UI
        const resultsContainer = document.getElementById('search-results-list');
        resultsContainer.innerHTML = '<p>There was an error fetching the search results. Please try again later.</p>';
    }
}

export default SearchResults;
